<template lang="pug">
  .agency-details
    h2.primary--text Beratung anlegen

    v-form(ref="form-consultation" lazy-validation @submit.prevent="() => {}")
      v-expansion-panels.mt-4(v-model="panel" flat tile multiple)
        v-expansion-panel
          v-expansion-panel-header Beratungadaten
          v-expansion-panel-content: v-row.my-6
            v-col.pb-0(v-if="ruleEngines.length !== 1" cols="12"): v-combobox(
              v-model="consultation.rule_engine"
              label="Rule Engine ID"
              outlined
              dense
              :items="ruleEngines"
              :item-text="`description`"
              :item-value="`id`"
              :rules="[ rules.required, rules.object ]"
            )
              template(#item="{ item }") {{ item.id }} - {{ item.description }} ({{ formatDateTime(item.created_at, 'DD.MM.YYYY HH:mm:ss') }})

            v-col.pb-0(sm="12"): v-text-field(
              v-model="consultation.name"
              label="Titel der Beratung"
              outlined
              :rules="[ rules.required ]"
            )

            v-col.pb-0(sm="12"): v-text-field(
              v-model="consultation.description"
              label="Beschreibung"
              outlined
            )

      v-btn.mt-8(block color="primary" :loading="loading" @click="onSave") Speichern

</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator'

import Urls from '@/router/urls'
import FormMixin from '@/mixins/form'

@Component({
  mixins: [
    FormMixin
  ]
})
export default class ConsultationDetails extends Vue {
  @Prop({ type: [ Number, String ], default: 0 }) id

  consultation = {
    rule_engine: null,
    name: '',
    description: ''
  }
  panel = [0]
  ruleEngines = []
  loading = false

  created () {
    this.loadRuleEngines()
  }

  loadRuleEngines () {
    return this.$axios
      .get(Urls.RuleEngine, {
        only_active: true
      })
      .then(res => {
        this.ruleEngines = res.data || []

        if (this.ruleEngines.length === 1) {
          this.consultation.rule_engine = this.ruleEngines[0]
        }
      })
  }

  onSave () {
    if (!this.isFormValid('form-consultation')) {
      return
    }

    const params = {
      name: this.consultation.name,
      description: this.consultation.description,
      rule_engine_id: this.consultation.rule_engine.id
    }

    this.loading = true

    this.$axios
      .post(Urls.Consultation(), params)
      .then(res => {
        this.$toast.success('Daten gespeichert', 'Speichern')
        this.$router.push({
          name: 'consultation-edit',
          params: {
            id: res.data.id
          }
        })
      })
      .catch(err => {
        this.$toast.error(err.message, 'Fehler')
      })
      .finally(() => {
        this.loading = false
      })
  }
}
</script>
